<section>
  <article [formGroup]="importForm" fxLayout="column">
    <mat-form-field appearance="outline">
      <mat-label>
        Title
      </mat-label>
      <input matInput type="text" formControlName="title">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>
        Director
      </mat-label>
      <input matInput type="text" formControlName="director">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>
        Production Year
      </mat-label>
      <input matInput type="text" formControlName="productionYear">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>
        Production Company
      </mat-label>
      <input matInput type="text" formControlName="productionCompany">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>
        Genres
      </mat-label>
      <input matInput type="text" formControlName="genre">
    </mat-form-field>
    <button mat-raised-button (click)="import()" style="background-color: green;">IMPORT</button>
  </article>
  <mat-divider></mat-divider>
  <article>
    <ng-container *ngFor="let movie of movies">
      <div fxLayout="column" fxLayoutGap="20px">
        <span>{{ movie.title }}</span>
        <span>{{ movie.director }}</span>
        <span>{{ movie.productionYear }}</span>
        <span>{{ movie.productionCompany }}</span>
        <span>{{ movie?.genre }}</span>
        <button mat-raised-button color="warn" (click)="deleteMovie(movie.id)">DELETE MOVIE</button>
        <mat-icon mat-icon-button color="accent" (click)="edit(movie)">edit</mat-icon>
        <mat-divider></mat-divider>
      </div>
    </ng-container>
  </article>
</section>